/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from '@vlinder-web/plugin-agent-service-react';
import {
  HeaderService,
  IHeaderMethods,
  FooterService,
  IFooterMethods,
  IStaticPageContentMethods,
  StaticPageContentService,
  UpdateProfileService,
  IUpdateProfileMethods,
  GetProfileService,
  IGetProfileMethods,
  ISetActiveMethods,
  ISetInactiveMethods,
  SetActiveService,
  SetInactiveService,
  ChangePasswordService,
  IChangePasswordMethods,
} from './plugins';

export type MyProfileAgent = IHeaderMethods &
  IFooterMethods &
  IStaticPageContentMethods &
  IUpdateProfileMethods &
  IGetProfileMethods &
  IChangePasswordMethods &
  ISetActiveMethods &
  ISetInactiveMethods;

const getPlugins = () => {
  return [
    new HeaderService(),
    new FooterService(),
    new StaticPageContentService(),
    new UpdateProfileService(),
    new GetProfileService(),
    new ChangePasswordService(),
    new SetActiveService(),
    new SetInactiveService(),
  ];
};

export const getAgent = () => {
  return createAgent<MyProfileAgent>({
    plugins: getPlugins(),
  });
};
